export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00404.68742278.png";